import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

export const termsOfServiceRoutes: RouteRender[] = [
  lazyView(
    routes.termsOfService,
    () => import("./terms-of-service").then((m) => ({ default: m.TermsOfServicePage })),
    "Terms of Service",
  ),
];
